import { defineMessages } from 'react-intl'

export const monthDefaultMessages = defineMessages({
  january: {
    id: 'ui.HouseSeasonalBusynessCalendarMonthElement.january',
    defaultMessage: 'Janvier',
  },
  february: {
    id: 'ui.HouseSeasonalBusynessCalendarMonthElement.february',
    defaultMessage: 'Février',
  },
  march: {
    id: 'ui.HouseSeasonalBusynessCalendarMonthElement.march',
    defaultMessage: 'Mars',
  },
  april: {
    id: 'ui.HouseSeasonalBusynessCalendarMonthElement.april',
    defaultMessage: 'Avril',
  },
  may: {
    id: 'ui.HouseSeasonalBusynessCalendarMonthElement.may',
    defaultMessage: 'Mai',
  },
  june: {
    id: 'ui.HouseSeasonalBusynessCalendarMonthElement.june',
    defaultMessage: 'Juin',
  },
  july: {
    id: 'ui.HouseSeasonalBusynessCalendarMonthElement.july',
    defaultMessage: 'Juillet',
  },
  august: {
    id: 'ui.HouseSeasonalBusynessCalendarMonthElement.august',
    defaultMessage: 'Août',
  },
  september: {
    id: 'ui.HouseSeasonalBusynessCalendarMonthElement.september',
    defaultMessage: 'Septembre',
  },
  october: {
    id: 'ui.HouseSeasonalBusynessCalendarMonthElement.october',
    defaultMessage: 'Octobre',
  },
  november: {
    id: 'ui.HouseSeasonalBusynessCalendarMonthElement.november',
    defaultMessage: 'Novembre',
  },
  december: {
    id: 'ui.HouseSeasonalBusynessCalendarMonthElement.december',
    defaultMessage: 'Décembre',
  },
})
